var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMainLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2299_2636",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 4,
    width: 26,
    height: 7
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.51611 4.23438H28.4841V10.8444H3.51611V4.23438Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2299_2636)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2299_2636",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 4,
    width: 26,
    height: 7
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.98763 4.23438H26.9886C27.3793 4.23438 27.7536 4.38971 28.0296 4.66571C28.3056 4.94171 28.4606 5.31604 28.4606 5.70638V9.37238C28.4606 9.76271 28.3056 10.1374 28.0296 10.4134C27.7536 10.6894 27.3793 10.8444 26.9886 10.8444H4.98763C4.59729 10.8444 4.22296 10.6894 3.94662 10.4134C3.67063 10.1374 3.51562 9.76271 3.51562 9.37238V5.70638C3.51562 5.31604 3.67063 4.94171 3.94662 4.66571C4.22296 4.38971 4.59729 4.23438 4.98763 4.23438Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2299_2636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.51562 4.23438H28.4576V10.8444H3.51562V4.23438Z",
    fill: "white",
    fillOpacity: 0.8
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2299_2636",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 13,
    width: 17,
    height: 7
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.51611 13.1953H19.8344V19.8053H3.51611V13.1953Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2299_2636)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2299_2636",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 13,
    width: 17,
    height: 7
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.98811 13.1953H18.3438C18.7344 13.1953 19.1088 13.3503 19.3848 13.6266C19.6608 13.9026 19.8158 14.277 19.8158 14.6673V18.3333C19.8158 18.7236 19.6608 19.098 19.3848 19.374C19.1088 19.6503 18.7344 19.8053 18.3438 19.8053H4.98811C4.59778 19.8053 4.22345 19.6503 3.94711 19.374C3.67111 19.098 3.51611 18.7236 3.51611 18.3333V14.6673C3.51611 14.277 3.67111 13.9026 3.94711 13.6266C4.22345 13.3503 4.59778 13.1953 4.98811 13.1953Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2299_2636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.51611 13.1953H19.8084V19.8053H3.51611V13.1953Z",
    fill: "white",
    fillOpacity: 0.8
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2299_2636",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 22,
    width: 20,
    height: 7
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52148 22.0059H28.4732V28.6159H9.52148V22.0059Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2299_2636)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_2299_2636",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 22,
    width: 20,
    height: 7
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.993 22.0078H26.9883C27.379 22.0078 27.7533 22.1631 28.0293 22.4391C28.3053 22.7151 28.4603 23.0895 28.4603 23.4798V27.1458C28.4603 27.5361 28.3053 27.9105 28.0293 28.1868C27.7533 28.4628 27.379 28.6178 26.9883 28.6178H10.993C10.6023 28.6178 10.228 28.4628 9.952 28.1868C9.676 27.9105 9.521 27.5361 9.521 27.1458V23.4798C9.521 23.0895 9.676 22.7151 9.952 22.4391C10.228 22.1631 10.6023 22.0078 10.993 22.0078Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_2299_2636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.521 22.0078H28.4727V28.6178H9.521V22.0078Z",
    fill: "white",
    fillOpacity: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogo);
export default __webpack_public_path__ + "static/media/main-logo.23e4241a846e1e1813410b565a24a353.svg";
export { ForwardRef as ReactComponent };